import NumberFormat from "react-number-format";

const CustomNumberFormat = ({
    onValueChange,
    id,
    label,
    value,
}) => {

    return (
        <div>
            <label htmlFor={id}>
                {label}
            </label>
            <div className="d-flex">
                <NumberFormat
                    id={id}
                    value={value}
                    onValueChange={onValueChange}
                    thousandSeparator={"."}
                    decimalSeparator={","}
                    className="form-control border-DCDCDC text-input"
                    style={{ height: "38px" }}
                />
                <p
                    style={{ color: "#000", marginLeft: -50, marginTop: 8 }}
                >
                    Rupiah
                </p>
            </div>
        </div >
    );
};

export default CustomNumberFormat;
